<template>
  <div class="solution_sheet__item" :class="classNames">
    <div class="solution_sheet__item__content">
      <p class="solution_sheet__item__title t-label t-label--dark">
        {{ title }}
      </p>

      <div class="solution_sheet__item__body">
        <slot />
      </div>
    </div>

    <div class="solution_sheet__item__illustration" v-if="$slots.illustration">
      <slot name="illustration" />
    </div>
  </div>
</template>

<script>
import { CalcIllustration } from "@/components";

export default {
  components: {
    CalcIllustration,
  },

  props: {
    title: {
      required: true,
      default: "Título por definir",
      type: String,
    },
  },

  computed: {
    classNames() {
      return [
        this.$slots.illustration
          ? "solution_sheet__item--has_illustration"
          : "",
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.solution_sheet__item {
  $root: &;

  position: relative;

  &:not(:last-child) {
    margin-bottom: $base-unit * 2;
  }

  &--has_illustration {
    display: flex;
    align-items: flex-end;

    #{$root}__content {
      flex-grow: 1;
    }
  }

  &__title {
    margin-bottom: $base-unit * (3/4);
  }
}

::v-deep .solution_sheet__item__val_table {
  width: auto;

  td:not(:last-child) {
    padding-right: 1em;
  }
}
</style>
